import { SearchOff } from '@mui/icons-material';
import { Box, ImageList, ImageListItem, Typography, useMediaQuery } from '@mui/material';
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Lightbox } from 'react-modal-image';

import ImageCard from '@sophocles/views/sites/components/media/ImageCard';

function ImageGallery({ images, onEdit, onDelete }) {
  const { t } = useTranslation();
  const isSmUp = useMediaQuery(theme => theme.breakpoints.up('sm'));
  const isTablet = useMediaQuery(theme => theme.breakpoints.up('md'));
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const isExtraLarge = useMediaQuery(theme => theme.breakpoints.up('xl'));

  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  return images.length === 0 ? (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        p: 8,
      }}
    >
      <SearchOff fontSize="large" sx={{ mb: 2 }} />
      <Typography variant="h7">{t('sites.noMediaFound', 'No media found')}</Typography>
    </Box>
  ) : (
    <Fragment>
      <ImageList cols={isExtraLarge ? 6 : isDesktop ? 4 : isTablet ? 3 : isSmUp ? 2 : 1}>
        {images.map((item, index) => (
          <ImageListItem key={item.image}>
            <ImageCard
              author={item.meta.uploader}
              image={item.image}
              title={item.meta.title}
              description={item.meta.description}
              uploadTime={item.meta.upload_time}
              onEdit={
                onEdit != null
                  ? () => {
                      onEdit(item);
                    }
                  : null
              }
              onDelete={
                onDelete != null
                  ? () => {
                      onDelete(item.id);
                    }
                  : null
              }
              onClick={() => {
                setSelectedImage(index);
                setIsLightBoxOpen(true);
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
      {isLightBoxOpen && (
        <Lightbox
          medium={images[selectedImage].image}
          large={images[selectedImage].image}
          onClose={() => setIsLightBoxOpen(false)}
        />
      )}
    </Fragment>
  );
}

export default ImageGallery;
